export const ACCOUNT_SETTINGS_ROUTE_MAP: Record<string, string> = {
  '/settings/account': '/account/account',
  '/settings/team/users': '/account/team/users',
  '/settings/team/roles': '/account/team/roles',
  '/settings/integrations': '/account/integrations',
  '/settings/calendar-feeds': '/account/calendar-feeds',
  '/settings/exports': '/account/exports',
  '/settings/local-cache': '/account/local-cache',
  '/settings/security-and-legal': '/account/security-and-legal',
  '/settings/security-and-legal/security': '/account/security-and-legal/security',
  '/settings/security-and-legal/sessions': '/account/security-and-legal/sessions',
  '/settings/security-and-legal/policy': '/account/security-and-legal/policy',
}

export const MOVED_MANAGE_SETTINGS_ROUTE_MAP: Record<string, string> = {
  '/settings/services/course-types': '/manage/course-types',
  '/settings/services/courses': '/manage/courses',
}

export const toCanonicalSettingsPath = (path: string): string | null => {
  if (path === '/settings') return '/manage'
  if (ACCOUNT_SETTINGS_ROUTE_MAP[path]) return ACCOUNT_SETTINGS_ROUTE_MAP[path]
  if (MOVED_MANAGE_SETTINGS_ROUTE_MAP[path]) return MOVED_MANAGE_SETTINGS_ROUTE_MAP[path]
  if (path.startsWith('/settings/')) return `/manage${path.slice('/settings'.length)}`
  if (path === '/online-booking') return '/minisite'
  if (path.startsWith('/online-booking/')) return `/minisite${path.slice('/online-booking'.length)}`
  return null
}
